import styled, { css } from "styled-components";
import { ReactComponent as Home } from "../../../assets/icons/ac.svg";
import { ReactComponent as View } from "../../../assets/icons/ac.svg";
import { ReactComponent as Inbox } from "../../../assets/icons/ac.svg";
import { ReactComponent as Favorite } from "../../../assets/icons/ac.svg";
export const getColor = ({ color }) => {
  switch (color) {
    case "desc":
      return "var(--common-desc-color)";
    case "blue":
      return "var(--common-blue-color)";
    case "chartColor":
      return "#A3A3A3";
    default:
      return "var(--common-dark-color)";
  }
};
export const getFontSize = ({ Size }) => {
  switch (Size) {
    case "title":
      return "var(--primary-title-size)";
    case "desc":
      return "var(--font-size-secondary)";
    case "content":
      return "var(--secondary-title-size)";
    default:
      return "var(--font-size-primary)";
  }
};
export const getLineHeight = ({ lineHeight }) => {
  switch (lineHeight) {
    case "title":
      return "38px";
    case "desc":
      return "18px";
    case "property":
      return "23px";
    default:
      return;
  }
};
export const getMargin = ({ margin }) => {
  switch (margin) {
    case "title":
      return "0 0 60px 0";
    case "desc":
      return "4px 0 0 0";
    case "content":
      return "0 0 30px 0";
    case "chart":
      return "0 30px 0 0";
    case "table":
      return "0 0 50px 0";
    case "copy":
      return "50px 0 0 0";
    default:
      return "0";
  }
};

export const Container = styled.div`
  padding: 60px 60px 50px 60px;
  background-color: var(--light-bg-color);
  flex-direction: column;
  display: flex;
`;
const Content = css`
  margin-left: 40px;
`;
const Chart = css`
  display: flex;
  flex-direction: row;
  @media (max-width: 1800px) {
    flex-direction: column;
  }
`;
export const Wrapper = styled.div`
  margin: ${getMargin};
  display: flex;
  flex-direction: column;
  ${({ content }) => content && Content}
  ${({ chart }) => chart && Chart};
`;
const Items = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: var(--default-text-color);
  border: 1px solid #e6e9ec;
  box-shadow: 0px 10px 30px rgba(13, 38, 59, 0.05);
  border-radius: 3px;
  width: 350px;
  transition: 0.3s ease-in-out;
  padding: 35px 70px 35px 30px;
  :hover {
    transform: scale(1.05);
  }
`;
Wrapper.Contents = styled.div`
  ${({ items }) => items && Items};
  display: flex;
  justify-content: ${({ main }) => main && "space-between"};
  flex-wrap: wrap;
  cursor: pointer;
  ${getMargin};
  margin-bottom: 30px;
`;

export const Title = styled.div`
  color: ${getColor};
  font-size: ${getFontSize};
  line-height: ${getLineHeight};
  font-weight: ${({ title }) => title && "600"};
  text-align: ${({ copy }) => copy && "center"};
  margin: ${getMargin};
`;
export const Icon = styled.div``;
Icon.Home = styled(Home)`
  width: 90px;
  height: 90px;
  padding: 25px;
  background: #eff4fd;
  border-radius: 38px;
`;
Icon.View = styled(View)`
  width: 90px;
  height: 90px;
  padding: 25px;
  background: #eff4fd;
  border-radius: 50px;
`;
Icon.Inbox = styled(Inbox)`
  width: 90px;
  height: 90px;
  padding: 25px;
  background: #eff4fd;
  border-radius: 50px;
`;
Icon.Favorite = styled(Favorite)`
  width: 90px;
  height: 90px;
  padding: 25px;
  background: #eff4fd;
  border-radius: 50px;
`;

Wrapper.Chart = styled.div``;
Wrapper.Activity = styled.div``;
